import { SelectOption } from "global";
import { LeadOption } from "../types";

export function convertLeadToOptions(options: LeadOption[] | undefined): SelectOption[] {
  if (!options || !options.length) return [];

  return options.map(({ value, businessName, contact }) => ({
    value,
    label: [businessName, contact].filter(Boolean).join(" - "),
  }));
}
